const ELFSIGHT_URL = /\.elfsight(cdn)?\.com/;

export const getSiteURL = (type: 'page' | 'site') => {
  const {
    location: { hostname, href }
  } = document;

  const url = {
    page: ELFSIGHT_URL.test(href) ? 'https://elfsight.com' : href,
    site: hostname
  }[type];

  return encodeURIComponent(url);
};
